
import { all, call, put, takeLatest } from "redux-saga/effects";
import { Types } from "../../types";
import { changeNotificationCustomerErrorAction, changeNotificationCustomerSuccessAction, deleteCustomerErrorAction, deleteCustomerSuccessAction, getCallTransferCustomerLineByCustomerMemberErrorAction, getCallTransferCustomerLineByCustomerMemberSuccessAction, getCallTransferQueueByCustomerErrorAction, getCallTransferQueueByCustomerSuccessAction, insertCustomerErrorAction, insertCustomerSuccessAction, updateCustomerErrorAction, updateCustomerSuccessAction } from "../../actions/customerAction";
import {  ChangeMemberNotificationCustomerSetting, deleteCustomerRequest, getCallTransferCustomerLineByCustomerMember, getCustomerMemberQueueByCustumerMember, newCustomerRequest, updateCustomerRequest } from "../apiRequests/cusomerRequest";
import { GetLineResponse, InsertUpdateResponse, newCUstomer } from "../../types/customer/apiRequestType";




function* insertCustomerHandler(action: any) {
    try {
        const response: { data: InsertUpdateResponse } = yield call(newCustomerRequest, action.payload)
        yield put(
            insertCustomerSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            insertCustomerErrorAction({
                error: error.message
            })
        )

    }
}


function* deleteCustomerHandler(action: any) {
    try {
        const response: { data: string } = yield call(deleteCustomerRequest, action.payload)
        yield put(
            deleteCustomerSuccessAction()
        )

    } catch (error: any) {
        yield put(
            deleteCustomerErrorAction({
                error: error
            })
        )

    }
}

function* updateCustomerHandler(action: any) {
    try {
        const response: { data: InsertUpdateResponse } = yield call(updateCustomerRequest, action.payload)
        yield put(
            updateCustomerSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            updateCustomerErrorAction({
                error: error.message
            })
        )

    }
}

function* ChangeMemberNotificationSettingHandler(action: any) {
    try {
        const response: { data: newCUstomer[] } = yield call(ChangeMemberNotificationCustomerSetting, action.payload)
        yield put(
            changeNotificationCustomerSuccessAction()
            
        )

    } catch (error: any) {
        yield put(
            changeNotificationCustomerErrorAction({
                error: error.message
            })
        )

    }
}


function* getCallTransferCustomerLineByCustomerMemberHandler(action: any) {
    try {
        const response: { data: GetLineResponse[] } = yield call(getCallTransferCustomerLineByCustomerMember, action.payload)
        yield put(
            getCallTransferCustomerLineByCustomerMemberSuccessAction({
                params: response.data
            })
            
        )

    } catch (error: any) {
        yield put(
            getCallTransferCustomerLineByCustomerMemberErrorAction({
                error: error.message
            })
        )

    }
}

function* getCustomerMemberQueueByCostumerMemberHandler(action: any) {
    try {
        const response: { data: GetLineResponse[] } = yield call(getCustomerMemberQueueByCustumerMember, action.payload)
        yield put(
            getCallTransferQueueByCustomerSuccessAction({
                params: response.data
            })
            
        )

    } catch (error: any) {
        yield put(
            getCallTransferQueueByCustomerErrorAction({
                error: error.message
            })
        )

    }
}

function* customerSaga() {
    yield all([takeLatest(Types.INSERT_CUSTOMER_REQUEST, insertCustomerHandler)]);
    yield all([takeLatest(Types.DELETE_CUSTOMER_REQUEST, deleteCustomerHandler)]);
    yield all([takeLatest(Types.UPDATE_CUSTOMER_REQUEST, updateCustomerHandler)]);
    yield all([takeLatest(Types.CHANGE_MEMBER_NOTIFICATION_REQUEST, ChangeMemberNotificationSettingHandler)]);
    yield all([takeLatest(Types.GET_LINE_ID_BY_CUSTOMER_ID_REQUEST, getCallTransferCustomerLineByCustomerMemberHandler)]);
    yield all([takeLatest(Types.GET_QUEUE_BY_CUSTOMER_ID_REQUEST, getCustomerMemberQueueByCostumerMemberHandler)]);

}

export default customerSaga